/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]  .invalid-feedback{display:block}[_nghost-%COMP%]  .fullWidth{width:100%}.normal-border[_ngcontent-%COMP%]{border:1px solid #d5d7e0;border-radius:4px}.error[_ngcontent-%COMP%]{border:1px solid #f13d37;border-radius:4px}"];
export { styles as styles };
